export const accountPage = () => {
    const toggleElements = document.querySelectorAll('.order-toggle');

    if (!toggleElements) {
        return;
    }

    toggleElements.forEach(function (toggleElement) {
        toggleElement.addEventListener('click', function () {
            const card = this.closest('.card');
            const collapse = card.querySelector('.collapse');
            collapse.classList.toggle('show');

            const toggleSign = this.querySelector('span');
            if (toggleSign.textContent === '-') {
                toggleSign.textContent = '+';
                this.classList.remove('order-toggle-background');
                toggleSign.classList.remove('toggle-sign-expanded');
            } else {
                toggleSign.textContent = '-';
                toggleSign.classList.add('toggle-sign-expanded');
                this.classList.add('order-toggle-background');
            }
        });
    });
};

